(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('PavillionDetailService', PavillionDetailService);

    PavillionDetailService.$inject = ['$http', '$log', 'API_URL', '$uibModal'];

    function PavillionDetailService($http, $log, API_URL, $uibModal) {
        // VARIABLES
        var vm = this;

        var service = {
            open: open,
            getDetails: getDetails,
        };
        var modalInstance = null;

        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function getDetails() {
            $log.debug("Load package details for package {}",vm.selectedPackage);
            return $http.get(API_URL + 'area/bookingoptiondetail', {params: {id: vm.selectedPackage.id}});
        }

        function open(selectedPackage) {
            if (modalInstance !== null) return;
            vm.selectedPackage = selectedPackage;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/area/pavillion/pavillion.detail.html',
                controller: 'PavillionDetailController',
                controllerAs: 'vm'
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();
